import CrudTable from "../../../crud/CrudTable"
import {statepreformService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Statepreform() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/statepreform/edit/"}
          urlnew={"/statepreform/new/"}
          filter={initFilter}
          i18n={"statepreform"}
          fieldstable={["id","name"]}
          estructureForm={createEstructureFilter} />
  );
}
